import { concat, from } from "rxjs";
import { isScheduler } from "../util";
export function endWith(...args) {
    let scheduler = args[args.length - 1];
    if (isScheduler(scheduler)) {
        args.pop();
    }
    else {
        scheduler = null;
    }
    return (source) => concat(source, from(args, scheduler));
}
//# sourceMappingURL=endWith.js.map